import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import LegalPageLayout from 'components/LegalPageLayout';
import { useI18n } from 'i18n/I18nContext';

const PrivacyPage = () => {
  const { t } = useI18n();

  return (
    <LegalPageLayout title={t('privacy.title')}>
      <p className="mb-25">{t('privacy.intro')}</p>
      <p className="mb-25 opacity-75 text-xs">{t('privacy.notice')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('privacy.h1')}</h2>
      <p className="mb-25">
        {t('privacy.p1Before')}{' '}
        <LocalizedLink className="text-green font-bold no-underline" to="/contact">
          {t('footer.contact')}
        </LocalizedLink>{' '}
        {t('privacy.p1After')}
      </p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('privacy.h2')}</h2>
      <p className="mb-25">
        {t('privacy.p2Before')}{' '}
        <LocalizedLink className="text-green font-bold no-underline" to="/cookies">
          {t('privacy.cookieLink')}
        </LocalizedLink>
        {t('privacy.p2After')}
      </p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('privacy.h3')}</h2>
      <p className="mb-25">{t('privacy.p3')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('privacy.h4')}</h2>
      <p className="mb-25">{t('privacy.p4')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('privacy.h5')}</h2>
      <p className="mb-25">{t('privacy.p5')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('privacy.h6')}</h2>
      <p className="mb-25">{t('privacy.p6')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('privacy.h7')}</h2>
      <p className="mb-25">{t('privacy.p7')}</p>
    </LegalPageLayout>
  );
};

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPage.tsx